import { fetchAuthenticatedJson } from './authenticatedFetch';

function buildQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }
    query.set(key, value);
  });
  const queryString = query.toString();
  return queryString ? `?${queryString}` : '';
}

export function fetchPatternPerformanceSummary(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/pattern-performance${buildQuery(filters)}`);
}

export function fetchPatternPerformanceComparison(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/pattern-performance/compare${buildQuery(filters)}`);
}

export function fetchPatternPerformanceDiagnostic(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/pattern-performance/diagnostic${buildQuery(filters)}`);
}

export function fetchPatternPerformanceCalibration(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/pattern-performance/calibration${buildQuery(filters)}`);
}

export function fetchPatternPerformanceDetail(detectionId) {
  return fetchAuthenticatedJson(`/api/admin/pattern-performance/${detectionId}`);
}

export function cleanupPatternPerformanceDuplicates(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/pattern-performance/cleanup-duplicates${buildQuery(filters)}`, {
    method: 'POST',
  });
}

export function purgePatternPerformanceHistory(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/pattern-performance/purge-history${buildQuery(filters)}`, {
    method: 'POST',
  });
}

export function purgeLegacyPatternPerformanceV1() {
  return fetchAuthenticatedJson('/api/admin/pattern-performance/purge-legacy-v1', {
    method: 'POST',
  });
}

export function purgeStablecoinPatternPerformanceData() {
  return fetchAuthenticatedJson('/api/admin/pattern-performance/purge-stablecoins', {
    method: 'POST',
  });
}